import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './services.css';
import catalog from '../../content/services/catalog.json';
import hy from '../../content/services/hy.json';
import ru from '../../content/services/ru.json';
import en from '../../content/services/en.json';
const Services = () => {
  const {
    t,
    i18n
  } = useTranslation();
  const locale = i18n.resolvedLanguage || 'hy';
  const content = { hy, ru, en }[locale] || en;
  return <section id="priceplans" className="services-section"><div className="our-services"><h2>{t('services_header')}</h2><p>{t('intro_paragraph1')}</p></div><div className="services-container">{catalog.map(({ slug }) => {
    const service = content.pages[slug];
    return <article className="service-item" key={slug}><h3><NavLink to={`/services/${slug}?lang=${locale}`}>{service.title}</NavLink></h3><p>{service.description}</p></article>;
  })}</div><p>{t('agency.quote')}</p><div className="more-link"><NavLink className="load-more" to={'/get-in-touch?lang=' + locale}>{t('agency.contact')}</NavLink></div></section>;
};
export default Services;
